module.exports = __webpack_public_path__ + "img/emo_06.1b4a6e3b.png";